var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10L5.4 11.9633C6.09796 10.751 6.9551 9.64082 7.95918 8.63674C9.43673 7.15919 11.1551 6 13.0694 5.19184C15.049 4.3551 17.151 3.93061 19.3224 3.93061C21.4939 3.93061 23.6 4.3551 25.5755 5.19184C27.4898 6 29.2082 7.15919 30.6857 8.63674C32.1633 10.1143 33.3225 11.8327 34.1306 13.7469C34.9714 15.7225 35.3959 17.8286 35.3959 20C35.3959 22.1714 34.9714 24.2776 34.1347 26.2531C33.3265 28.1673 32.1673 29.8857 30.6898 31.3633C29.2122 32.8408 27.4939 34 25.5796 34.8082C23.6 35.6449 21.498 36.0694 19.3265 36.0694C17.9265 36.0694 16.5429 35.8898 15.2041 35.5388C13.9102 35.1959 12.6571 34.6898 11.4857 34.0327C9.17551 32.7388 7.19592 30.8735 5.77143 28.6367C5.6449 28.4367 5.52245 28.2367 5.40408 28.0327L2 30C2.14694 30.2571 2.30204 30.5061 2.45714 30.7551C6.01225 36.3143 12.2367 40 19.3224 40C30.3673 40 39.3225 31.0449 39.3225 20C39.3225 8.9551 30.3673 0 19.3224 0C11.9224 0 5.45714 4.02041 2 10Z",
    fill: "#2196F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/RefreshIcon.d56153bfd854b7be732c4ce788e2a2be.svg";
export { ForwardRef as ReactComponent };